import { render, staticRenderFns } from "./CRUDGuias.vue?vue&type=template&id=05534675&"
import script from "./CRUDGuias.vue?vue&type=script&lang=js&"
export * from "./CRUDGuias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports